import React from 'react';
import type { To, NavigateOptions as RouterNavigateOptions } from 'react-router-dom';
import { useNavigate as useRouterNavigate } from 'react-router-dom';

interface NavigateOptions<TState = unknown> extends RouterNavigateOptions {
  state?: TState;
}

type Navigate<TState = unknown> = (to: To, options?: NavigateOptions<TState>) => void;

export const useNavigate = <TState = unknown>() => {
  const navigate = useRouterNavigate();

  return navigate as Navigate<TState>;
};

export const useNavigateBack = () => {
  const navigate = useRouterNavigate();

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line no-restricted-syntax
  return React.useCallback(() => {
    navigate(
      {
        pathname: '..',
      },
      {
        relative: 'route',
      },
    );
  }, [navigate]);
};
